import { NavLink } from 'react-router-dom';
import idCard from './id_card.svg';
import document from './document.svg';
import complaint from './complaint.svg';
import statement from './statement.svg';

function CardAction() {
  return (
    <>
      <div className="content-body">
        <nav className="row gy-4">
          <div className="col-xl col-lg-2 col-md-2 col-4"><NavLink className="item-link text-center" to="/console/statement">
            <div className="icon icon-lg mb-2 rounded-3">
              <img src={statement} className="img-icon" />
            </div>
            <div className="text action-link"> Statement</div>
          </NavLink></div>
          <div className="col-xl col-lg-2 col-md-2 col-4"><NavLink className="item-link text-center" to="/console/card">
            <div className="icon icon-lg mb-2 rounded-3">
              <img src={idCard} className="img-icon" />
            </div>
            <div className="text action-link"> Card</div>
          </NavLink></div>
          <div className="col-xl col-lg-2 col-md-2 col-4"><NavLink className="item-link text-center" to="/console/benefit">
            <div className="icon icon-lg mb-2 rounded-3">
              <img src={document} className="img-icon" />
            </div>
            <div className="text action-link"> Claims</div>
          </NavLink></div>
          <div className="col-xl col-lg-2 col-md-2 col-4"><NavLink className="item-link text-center" to="/console/complaint">
            <div className="icon icon-lg mb-2 rounded-3">
              <img src={complaint} className="img-icon" />
            </div>
            <div className="text action-link"> Complaints</div>
          </NavLink></div>
        </nav>
      </div>
    </>
  );
}
export default CardAction;
